import gql from 'graphql-tag';

const GET_CAMPAIGN_ORDER_REQUESTOR_ADVERTISER = gql`
  query CampaignRequestorAdvertiser($where: OrgWhereUniqueInput!) {
    org(where: $where) {
      id
      name
      cpm
      dataConfig {
        dspAdvertiserId
      }
      pricingModel {
        id
        model
        hasContract
        cpmList {
          id
          type
          advertiserCPM
          contractCPM
        }
        auctionPlus {
          id
          advertiserPercentage
          contractPercentage
        }
      }
    }
  }
`;

export default GET_CAMPAIGN_ORDER_REQUESTOR_ADVERTISER;
